import { classNames } from "../../helpers/classNames";

const Cards = ({ children, title = "card title", header, description = "card description", bodyClass }) => {
  return (
    <div className="rounded-md  hover:shadow-md border border-slate-100 flex flex-col">
      {header !== false && header ? (
        header
      ) : (
        <div className="bg-slate-100 min-h-10 px-4 py-3 -space-y-[2px]">
          <div className="font-semibold text-base">{title}</div>
          <div className="text-gray-500 text-sm">{description}</div>
        </div>
      )}
      <div className={classNames("flex-grow p-4", bodyClass)}>{children}</div>
    </div>
  );
};

export default Cards;
